export const confidentialityLayoutPath = 'confidentiality'
/**
 * src/common/components/paths.ts:11
 * const settingsModalPath = '/settings'
 * @deprecated
 * @type {string}
 */
export const layoutSettingsPath = 'settings'
